import "./stylesCustomInput.css";

import Input from "../../shared/Input/Input";
import { AppStrings } from "../../../utils/constants/AppStrings";

/**
 * @deprecated Use `Input` from `components/shared` with `variant="search"`:
 *
 *   <Input variant="search" placeholder="Search users" />
 *
 * The wrapper below preserves the original prop surface (size="large",
 * default search prefix, default "Search" placeholder) so existing
 * consumers keep rendering identically. Migration of those consumers
 * happens incrementally during cleanup waves.
 */
function CustomInput({
  placeholder = AppStrings.SEARCH,
  size = "large",
  className = "",
  style = {},
  allowClear = false,
  ...props
}) {
  return (
    <Input
      variant="search"
      className={`custom-input ${className}`.trim()}
      size={size}
      placeholder={placeholder}
      style={style}
      allowClear={allowClear}
      {...props}
    />
  );
}

export default CustomInput;
